import type { SVGProps } from 'react'

interface ProcessIconProps extends SVGProps<SVGSVGElement> {}

export function ProcessIcon(props: ProcessIconProps) {
  return (
    <svg
      width="28"
      height="31"
      viewBox="0 0 28 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8335 1V3.88893M16.1669 1V3.88893M8.22233 7.5001H5.3334M8.22233 11.8335H5.3334M22.667 7.5001H19.7781M22.667 11.8335H19.7781M14.0002 25.5559C14.6733 25.5559 15.0099 25.5559 15.2757 25.6671C15.6292 25.8134 15.9102 26.0939 16.0571 26.4472C16.1669 26.7129 16.1669 27.0495 16.1669 27.7226C16.1669 28.3957 16.1669 28.7323 16.0557 28.9981C15.9094 29.3516 15.6289 29.6326 15.2757 29.7795C15.0099 29.8893 14.6733 29.8893 14.0002 29.8893C13.3271 29.8893 12.9905 29.8893 12.7247 29.7795C12.3712 29.6333 12.0902 29.3513 11.9433 28.9981C11.8335 28.7323 11.8335 28.3957 11.8335 27.7226C11.8335 27.0495 11.8335 26.7129 11.9447 26.4472C12.091 26.0937 12.3715 25.8126 12.7247 25.6657C12.9905 25.5559 13.3271 25.5559 14.0002 25.5559ZM14.0002 25.5559V15.4447M15.9257 3.88893H12.0747C10.259 3.88893 9.34901 3.88893 8.78567 4.45227C8.22233 5.0185 8.22233 5.92563 8.22233 7.74277V11.5937C8.22233 13.4094 8.22233 14.318 8.78567 14.8828C9.35046 15.4461 10.259 15.4461 12.0747 15.4461H15.9257C17.7414 15.4461 18.6499 15.4461 19.2147 14.8828C19.7781 14.318 19.7781 13.4094 19.7781 11.5937V7.74132C19.7781 5.92563 19.7781 5.01706 19.2147 4.45372C18.6499 3.88893 17.7414 3.88893 15.9257 3.88893ZM1.89124 29.7795C2.15702 29.8893 2.49358 29.8893 3.1667 29.8893C3.83982 29.8893 4.17638 29.8893 4.44216 29.7795C4.79539 29.6326 5.07591 29.3516 5.22217 28.9981C5.3334 28.7323 5.3334 28.3957 5.3334 27.7226C5.3334 27.0495 5.3334 26.7129 5.22362 26.4472C5.0767 26.0939 4.79566 25.8134 4.44216 25.6671C4.17638 25.5559 3.83982 25.5559 3.1667 25.5559C2.49358 25.5559 2.15702 25.5559 1.89124 25.6657C1.53801 25.8126 1.25749 26.0937 1.11122 26.4472C1 26.7129 1 27.0495 1 27.7226C1 28.3957 1 28.7323 1.10978 28.9981C1.25669 29.3513 1.53774 29.6333 1.89124 29.7795Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.16626 25.5559C3.16626 23.5278 3.16626 22.5124 3.65304 21.7844C3.86387 21.4688 4.13481 21.1979 4.45039 20.987C5.1784 20.5002 6.19386 20.5002 8.22189 20.5002H19.7776C21.8056 20.5002 22.8211 20.5002 23.5491 20.987C23.864 21.1979 24.1356 21.4695 24.3465 21.7844C24.8332 22.5124 24.8332 23.5278 24.8332 25.5559M24.8332 25.5559C25.5064 25.5559 25.8429 25.5559 26.1087 25.6671C26.4622 25.8134 26.7433 26.0939 26.8902 26.4471C26.9999 26.7129 26.9999 27.0495 26.9999 27.7226C26.9999 28.3957 26.9999 28.7323 26.8887 28.998C26.7425 29.3515 26.4619 29.6326 26.1087 29.7795C25.8429 29.8893 25.5064 29.8893 24.8332 29.8893C24.1601 29.8893 23.8236 29.8893 23.5578 29.7795C23.2043 29.6332 22.9232 29.3513 22.7763 28.998C22.6666 28.7323 22.6666 28.3957 22.6666 27.7226C22.6666 27.0495 22.6666 26.7129 22.7778 26.4471C22.924 26.0936 23.2046 25.8126 23.5578 25.6657C23.8236 25.5559 24.1601 25.5559 24.8332 25.5559Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="1.82593"
        y="25.7622"
        width="3.30164"
        height="3.30164"
        fill="currentColor"
      />
      <rect
        x="12.5562"
        y="25.7622"
        width="3.30164"
        height="3.30164"
        fill="currentColor"
      />
      <rect
        x="23.2864"
        y="25.7622"
        width="3.30164"
        height="3.30164"
        fill="currentColor"
      />
    </svg>
  )
}
